import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { KotlinLoggingConfiguration_getInstance2pq6qv2bwynbv as KotlinLoggingConfiguration_getInstance } from './KotlinLoggingConfiguration.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var Level_TRACE_instance;
var Level_DEBUG_instance;
var Level_INFO_instance;
var Level_WARN_instance;
var Level_ERROR_instance;
var Level_OFF_instance;
var Level_entriesInitialized;
function Level_initEntries() {
  if (Level_entriesInitialized)
    return Unit_instance;
  Level_entriesInitialized = true;
  Level_TRACE_instance = new (Level())('TRACE', 0, 0, 'TRACE');
  Level_DEBUG_instance = new (Level())('DEBUG', 1, 10, 'DEBUG');
  Level_INFO_instance = new (Level())('INFO', 2, 20, 'INFO');
  Level_WARN_instance = new (Level())('WARN', 3, 30, 'WARN');
  Level_ERROR_instance = new (Level())('ERROR', 4, 40, 'ERROR');
  Level_OFF_instance = new (Level())('OFF', 5, 50, 'OFF');
}
var LevelClass;
function Level() {
  if (LevelClass === VOID) {
    class $ extends Enum() {
      constructor(name, ordinal, levelInt, levelStr) {
        super(name, ordinal);
        this.w2g_1 = levelInt;
        this.x2g_1 = levelStr;
      }
      y2g() {
        return this.i5(KotlinLoggingConfiguration_getInstance().t2f_1.z2g()) >= 0;
      }
      toString() {
        return this.x2g_1;
      }
    }
    initMetadataForClass($, 'Level');
    LevelClass = $;
  }
  return LevelClass;
}
function Level_DEBUG_getInstance() {
  Level_initEntries();
  return Level_DEBUG_instance;
}
function Level_INFO_getInstance() {
  Level_initEntries();
  return Level_INFO_instance;
}
function Level_ERROR_getInstance() {
  Level_initEntries();
  return Level_ERROR_instance;
}
//region block: exports
export {
  Level_DEBUG_getInstance as Level_DEBUG_getInstance2qkta2bzcdm6b,
  Level_ERROR_getInstance as Level_ERROR_getInstance253jkotxjexvf,
  Level_INFO_getInstance as Level_INFO_getInstance24xg9wydggzl5,
};
//endregion

//# sourceMappingURL=Level.mjs.map
